import {
	applyNatConfigFilter,
	focusNatConfig,
	openNatConfigSection,
} from './adapter';
import {
	openNatConfigCreateModal,
	openNatConfigDeleteModal,
	openNatConfigEditModal,
} from './modal';
import {resolveNatConfigs} from './resolver';

/**
 * NAT profiles.
 *
 * NAT profiles under Global Profiles. The resource is nat_config
 * so "nat profile" keeps answering as the SSID and AP field of that
 * name, the way user_role leaves "role" to the WAN setting.
 *
 * Declares no fields: the Add and Edit forms are not mapped, so the agent
 * finds a profile and opens the form rather than filling it in. Delete
 * opens the confirmation and stops - the person presses the button.
 */
const natConfigPlugin = {
	id: 'nat_config',
	version: 1,
	commandVersion: 1,
	resource: 'nat_config',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.nat_configs': openNatConfigSection,
	},
	resolvers: {
		nat_config: resolveNatConfigs,
	},
	filters: {
		nat_config: (command) => applyNatConfigFilter(command.params?.query),
	},
	focusHandlers: {
		nat_config: (command) => focusNatConfig(command.params?.entity_id),
	},
	modals: {
		'nat_config.create': openNatConfigCreateModal,
		'nat_config.edit': openNatConfigEditModal,
		'nat_config.delete': openNatConfigDeleteModal,
	},
};

export default natConfigPlugin;
